import React from 'react';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Row from 'src/components/10-atoms/layout/Row';
import Typography from 'src/components/10-atoms/typography/Typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
const FilterSelectChipValue = ({ label, leftIcon, spacing, }) => {
    const [{ theme, styles }] = useTheme(stylesGenerator);
    return (React.createElement(Row, { xAxis: "space-between", yAxis: "center", spacing: theme.spacing.standard.xs, style: styles.root },
        React.createElement(Row, { yAxis: "center", spacing: spacing ?? theme.spacing.standard.xs, style: styles.labelRow },
            leftIcon,
            React.createElement(Typography, { numberOfLines: 1 }, label)),
        React.createElement(FeatherIcon, { name: "chevron-down", size: theme.iconSize.xs, color: theme.palette.typography.primary })));
};
const stylesGenerator = createThemedStyle(({}) => ({
    root: {
        width: '100%',
    },
    labelRow: {
        minWidth: 0,
        flexShrink: 1,
    },
}));
export default FilterSelectChipValue;
